import React from "react";
import { useNavigate } from "react-router-dom";

const VacancyDetail = ({ content }) => {
  const navigate = useNavigate();
  return (
    <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row justify-between lg:items-center gap-8 max-xl:px-6 mt-16">
      <div className=" max-w-[789px] flex flex-col gap-5">
        {content.map((item, index) => (
          <div key={index} className="flex flex-col gap-4 text-darkGray">
            <h3 className="text-2xl font-bold">{item.title}</h3>

            {Array.isArray(item.content) && (
              <div className="flex flex-col gap-">
                {item.content.map((desc, idx) => (
                  <p key={idx} className="text-lg text-darkGray/70 mb-4">
                    {desc}
                  </p>
                ))}
              </div>
            )}
            {item.requirements && (
              <ul className="list-disc pl-5">
                {item.requirements.map((item, idx) => (
                  <li key={idx} className="text-lg text-darkGray/70 mb-4">
                    {item}
                  </li>
                ))}
              </ul>
            )}
            {item.tools && (
              <ul className="list-disc pl-5">
                {item.tools.map((tool, idx) => (
                  <li key={idx} className="text-lg text-darkGray/70 mb-4">
                    {tool.name} : {tool.description}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>

      <div className="bg-whiteSmoke/30 lg:max-w-[379px] flex-1 article-connect p-8">
        <h4 className="text-2xl font-bold text-darkGray mb-8">
          Apply for this role
        </h4>
        <button onClick={() => navigate('/careers/vacancy-application')} className="w-full border-2 border-darkPurple text-darkPurple font-semibold text-sm rounded-full px-6 py-3">
          Apply
        </button>
      </div>
    </div>
  );
};

export default VacancyDetail;
